import { render } from "./my-icon.vue?vue&type=template&id=6d4a0398&ts=true"
import script from "./my-icon.vue?vue&type=script&lang=ts"
export * from "./my-icon.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__